import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {BehaviorSubject, Observable, of, take, tap} from "rxjs";
import {catchError, filter, map} from 'rxjs/operators';
import {RequestToken} from '@core/models/request-token';
import {UsuarioExterno} from '@core/models/usuario-externo';
import {environment} from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoginExternoService {

  private readonly apiUri = environment.api.uri.concat('usuario-externo');
  private readonly usuarioLogado$ = new BehaviorSubject<UsuarioExterno | null>(null);

  constructor(private readonly http: HttpClient) {
  }

  get user(): UsuarioExterno | null {
    return this.usuarioLogado$.value;
  }

  get userObservable(): Observable<UsuarioExterno | null> {
    return this.usuarioLogado$.asObservable();
  }

  requestToken(email: string): Observable<any> {
    const url = `${this.apiUri}/request-token`;
    return this.http.post<any>(url, {email});
  }

  validateToken(
    email: string,
    token: string
  ) {
    const url = `${this.apiUri}/validate-token`;
    return this.http.post<RequestToken>(url, {email, token});
  }

  getUsuarioLogado(): Observable<UsuarioExterno> {
    return this.http.get<UsuarioExterno>(`${this.apiUri}/obter-usuario-externo`, {}).pipe(
      tap(usuario => this.usuarioLogado$.next(usuario))
    );
  }

  isAdministrador(): Observable<boolean> {
    return this.userObservable.pipe(
      filter(user => !!user),
      take(1),
      map(user => {
        return !!user?.administrador;
      }),
      catchError(() => {
        return of(false);
      })
    );
  }
}
